import Elevator from '@/modules/display/data/elevator';

export const elevatorForm = {
  namespaced: true,
  state: {
    elevator : new Elevator(),
    listeners: [],
    closeListeners: [],
    closeForm: {}
  },
  mutations: {
    resetForm(state) {
      state.elevator = new Elevator();
    },
    setElevator(state, elevator) {
      if (elevator != null) {
        state.elevator = elevator;
      }
    },
    setElevatorId(state, elevatorId) {
      if (elevatorId !== null && elevatorId !== '00000000-0000-0000-0000-000000000000') {
        state.elevator.id = elevatorId;
      }
    },
    setCloseForm(state, method) {
      if (method !== null) {
        state.closeForm = method;
      }
    },
    closeWindow(state) {
      state.closeForm();
    },
    updateBackgroundUrl(state, url) {
      if (url !== null) {
        state.elevator.urlBackground = url;
      }
    },
    updateLogoUrl(state, url) {
      if (url !== null) {
        state.elevator.urlLogo = url;
      }
    },
    updateMediaType(state, type) {
      if (type !== null) {
        state.elevator.mediaType = type;
      }
    },
    updateMediaId(state, mediaId) {
      if (mediaId !== null) {
        state.elevator.mediaId = mediaId;
      }
    },
    updatedOptions(state, options) {
      if (options !== null) {
        state.elevator.options = options;
      }
    },
    updateTags(state, tags) {
      state.elevator.tags = [];
      if (tags !== null) {
        state.elevator.tags = tags;
      }
    },
    updateBlackTags(state, blackTags) {
      state.elevator.blackTags = [];
      if (blackTags !== null) {
        state.elevator.blackTags = blackTags;
      }
    },
    addListener(state, listener) {
      if (listener != null) {
        state.listeners.push(listener);
      }
    },
    addCloseListener(state, closeListener) {
      if (closeListener != null) {
        state.closeListeners.push(closeListener);
      }
    },
    updateVast(state, vast) {
      if (vast !== null) {
        state.elevator.vastList = [vast];
      }
    },
    beforeClose(state) {
      let closeListeners = state.closeListeners;
      for (let i = 0; i < closeListeners.length; i++) {
        closeListeners[i]();
      }
    },
    updateForm(state) {
      let listeners = state.listeners;
      for (let i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    updateButtonContent(state, buttonContent) {
      if (buttonContent !== null) {
        state.elevator.buttonContent = buttonContent;
      }
    },
    updateAdditionalElevators(state, additionalElevators) {
      if (additionalElevators !== null) {
        state.elevator.additionalElevators = additionalElevators;
      }
    }
  },
  getters: {
    getTags: (state) => state.elevator.tags
  }
}